import axios, { AxiosRequestHeaders } from 'axios'
import { useAuthStore } from '@/stores/auth.store'

const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1/'

const apiService = axios.create({
  baseURL: BASE_URL,
})

apiService.defaults.headers.common['Content-Type'] = 'application/json'
apiService.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

apiService.interceptors.request.use(
  async (config) => {
    const authStore = useAuthStore()
    const token = authStore.accessToken || ''
    const refreshToken = authStore.refreshToken || ''
    config.headers = {
      Authorization: config.url !== 'authen/refresh-token' ? `Bearer ${token}` : `Bearer ${refreshToken}`,
    } as AxiosRequestHeaders
    return config
  },
  (error) => {
    Promise.reject(error).then((r) => r)
  },
)

apiService.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    const originalRequest = error.config
    const errMessage = error.response
    if (errMessage.status === 401 && !originalRequest.url.includes('auth/refresh') && !originalRequest._retry) {
      originalRequest._retry = true
      const authStore = useAuthStore()
      await authStore.refresh()
      originalRequest.headers.Authorization = `Bearer ${authStore.accessToken}`
      return apiService(originalRequest)
    }
    return Promise.reject(error)
  },
)

export default apiService
